export const state = {
    client: {
        host: [],
        username: null,
        enabled: null,
        notifyOnSnatch: null,
        notifyOnDownload: null,
        notifyOnSubtitleDownload: null
    },
    server: {
        updateLibrary: null,
        host: [],
        enabled: null,
        https: null,
        username: null,
        password: null,
        token: null
    }
};

export const mutations = {};

export const getters = {};

export const actions = {};

export default {
    state,
    mutations,
    getters,
    actions
};
